import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=551d3f9e&scoped=true&"
import script from "./parameters.vue?vue&type=script&lang=js&"
export * from "./parameters.vue?vue&type=script&lang=js&"
import style0 from "./parameters.vue?vue&type=style&index=0&id=551d3f9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d3f9e",
  null
  
)

export default component.exports